module.exports = __webpack_public_path__ + "img/logotyp_z_bialym_napisem_bez_dat.0dedf0b0.png";